import React from 'react'
import CatholicHouseholdMemberQuery from "./CatholicHouseholdMemberQuery";


export const CatholicHouseholdMemberQueryFirstCommunion = ({
                                                               ...props
                                                           }) => <CatholicHouseholdMemberQuery
    sacrament_type={"first_communion"} {...props} />


